var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatisticsColor2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "22px",
    viewBox: "0 0 23 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stats-color",
    transform: "translate(1.000000, 1.000000)",
    fillRule: "nonzero",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.214904,13.8932411 C18.5785762,15.3980749 17.5833054,16.72412 16.3161023,17.7554462 C15.0488991,18.7867724 13.5483476,19.4919782 11.9456385,19.8094074 C10.3429295,20.1268366 8.68686103,20.046825 7.12221786,19.5763683 C5.55757469,19.1059116 4.13199658,18.2593344 2.97011849,17.1106495 C1.80824039,15.9619645 0.945438784,14.5461469 0.457145297,12.9869782 C-0.0311481893,11.4278094 -0.130065835,9.7727626 0.169040517,8.16653318 C0.468146868,6.56030377 1.15616985,5.05179748 2.17295807,3.77289975 C3.18974629,2.49400201 4.50434054,1.48365171 6.00180964,0.830181019",
    id: "Vector",
    stroke: "#488BC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2437003,6.17461155 C18.7410355,4.96107143 18.0042674,3.85842175 17.075464,2.92961837 C16.1466606,2.000815 15.0440109,1.26404781 13.8304708,0.761383053 C12.6169307,0.258718291 11.316266,0 10.0027396,0 L10.0027396,10.0023428 L20.0050824,10.0023428 C20.0050824,8.6888164 19.746365,7.38815167 19.2437003,6.17461155 Z",
    id: "Vector",
    stroke: "#4CA084"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsColor2);
export default __webpack_public_path__ + "static/media/statistics-color2.450a81dec9cd75750e1c15a6a3663b71.svg";
export { ForwardRef as ReactComponent };